import { axiosV2 } from "config/@axios";
import __axios from "axios";
import * as uiActions from "store/actions/uiActions";
import { redirect } from "react-router";
import i18next from "i18next";
import { syncTaskMessageReminders } from "pages/Mail/Messages/store/reminderActions";
export const SET_PARAMS = "tasksActions::setParams";
export const SET_SELECTED = "tasksActions::setSelected";
export const RESET_SELECTED = "tasksActions::resetSelected";
export const FETCH_TASKS = "tasksActions::fetchTasks";
export const FETCH_TASKS_SUCCESS = "tasksActions::fetchTasksSuccess";
export const FETCH_TASKS_FAILED = "tasksActions::fetchTasksFailed";
export const FETCH_TASK = "tasksActions::fetchTask";
export const FETCH_TASK_SUCCESS = "tasksActions::fetchTaskSuccess";
export const FETCH_TASK_FAILED = "tasksActions::fetchTaskFailed";
export const SUBMIT_TASK = "tasksActions::submitTask";
export const SUBMIT_TASK_SUCCESS = "tasksActions::submitTaskSuccess";
export const SUBMIT_TASK_FAILED = "tasksActions::submitTaskFailed";
export const REMIND_TASK = "tasksActions::remindTask";

const CancelToken = __axios.CancelToken;
let cancel;

export const setSelected = payload => {
  return {
    type: SET_SELECTED,
    payload
  };
};

export const resetSelected = () => {
  return {
    type: RESET_SELECTED
  };
};

export const setParams = payload => {
  return {
    type: SET_PARAMS,
    payload
  };
};

export const remindTask = payload => {
  return {
    type: REMIND_TASK,
    payload
  };
};

export const deleteTask = id => (dispatch, getState) => {
  cancel && cancel();
  const task = getState().tasks.selected;
  return axiosV2
    .delete("/tasks/" + id, {
      cancelToken: new CancelToken(function executor(e) {
        cancel = e;
      })
    })
    .then(response => {
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("tasks:messages.deleted")
        })
      );
      redirect("/tasks");
      dispatch(syncTaskMessageReminders(task));
      dispatch(resetSelected());
      dispatch(setParams(getState().tasks.params));
    })
    .catch(thrown => {
      if (__axios.isCancel(thrown)) {
        return;
      }
    })
    .finally(() => {
      cancel = null;
    });
};

export const editTask = (id, data) => (dispatch, getState) => {
  cancel && cancel();
  const task = getState().tasks.selected;
  dispatch({
    type: SUBMIT_TASK
  });
  axiosV2
    .put(`tasks/${id}`, data)
    .then(response => {
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("tasks:messages.edit_success")
        })
      );
      dispatch({
        type: SUBMIT_TASK_SUCCESS,
        payload: response.data
      });
      dispatch(syncTaskMessageReminders(getState().tasks.selected));
      if (task?.messageInfo !== getState().tasks.selected?.messageInfo) {
        dispatch(syncTaskMessageReminders(task));
      }
      dispatch(setParams(getState().tasks.params));
    })
    .catch(thrown => {
      dispatch({
        type: SUBMIT_TASK_FAILED,
        payload: {
          errorText: thrown.errorMessage
        }
      });
    });
};

export const fetchTask = id => dispatch => {
  dispatch({
    type: FETCH_TASK,
    payload: id
  });

  return axiosV2
    .get("/tasks/" + id)
    .then(response => {
      dispatch({
        type: FETCH_TASK_SUCCESS,
        payload: response.data
      });
    })
    .catch(thrown => {
      dispatch({
        type: FETCH_TASK_FAILED,
        payload: {
          errorText: thrown.errorMessage
        }
      });
    });
};

export const fetchTasks = params => dispatch => {
  cancel && cancel();
  dispatch({
    type: FETCH_TASKS
  });

  axiosV2
    .get("/tasks", {
      params,
      cancelToken: new CancelToken(function executor(e) {
        cancel = e;
      })
    })
    .then(response => {
      dispatch({
        type: FETCH_TASKS_SUCCESS,
        payload: {
          data: response.data,
          total: response.headers["x-total-count"]
        }
      });
    })
    .catch(thrown => {
      if (__axios.isCancel(thrown)) {
        return;
      }

      dispatch({
        type: FETCH_TASKS_FAILED,
        payload: {
          errorText: thrown.errorMessage
        }
      });
    })
    .finally(() => {
      cancel = null;
    });
};
